export const TRANSLATION_NAMESPACE = 'createLessonModalV2';
